import React from 'react';
import classes from '../Notifications/notification.module.css';
import cn from 'classnames';
import { getCheckSourceIcon } from '../../../../utility/fireboardUtil';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const ErrorTable = ({ errorOrdersList }) => {
  const formateDateTime = isoString => {
    const dateObj = new Date(isoString);

    const date = dateObj.toLocaleDateString(undefined, {
      day: '2-digit',
      month: '2-digit',
    });
    const time = dateObj.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return (
      <div>
        <div>{date}</div>
        <div>{time}</div>
      </div>
    );
  };

  const channelColor = 'var(--primary-icon-color)';

  const columns = [
    {
      Header: FLABEL().ERROR_CHANNEL,
      accessor: row => getCheckSourceIcon(row?.sourceType, channelColor),
      style: 'col-1',
    },
    { Header: FLABEL().ERROR_CHECK_NUMBER, accessor: row => row?.number, style: 'col-1' },
    { Header: FLABEL().ERROR_NAME, accessor: row => row?.stationName, style: 'col-2' },
    {
      Header: FLABEL().ERROR_PHONE_NUMBER,
      accessor: row => getFormatedPhoneNumber(row?.orders?.[0]?.phoneNumber),
      style: 'col-2',
    },
    {
      Header: FLABEL().ERROR_PICKUP_DETAILS,
      accessor: row => formateDateTime(row?.orders?.[0]?.pickupDate),
      style: 'col-2',
    },
    {
      Header: FLABEL().ERROR_ERROR_MESSAGE,
      accessor: row => row?.orders?.[0]?.message,
      style: 'col-4 px-0 text-left',
    },
  ];

  return (
    <div className={cn(classes.container, 'fs-12 h-100')}>
      <div
        className={cn(classes.tableHeader, 'row mx-0 align-items-center my-3')}
      >
        {columns.map(col => (
          <div className={cn(col.style, 'text-center')}>{col.Header}</div>
        ))}
      </div>

      <div className={cn(classes.notificationList)}>
        {errorOrdersList?.length > 0 ? (
          errorOrdersList.map(row => (
            <div
              key={row?.notification?.id}
              className={cn(
                classes.notificationBody,
                'row mx-0 mb-1 align-items-center'
              )}
            >
              {columns.map(col => {
                let cellValue =
                  typeof col.accessor === 'function'
                    ? col.accessor(row)
                    : row[col.accessor];

                return (
                  <div className={cn(col.style, classes.cell, 'text-center')}>
                    {cellValue || '--'}
                  </div>
                );
              })}
            </div>
          ))
        ) : (
          <div
            className={cn(
              'h-100 d-flex justify-content-center align-items-center',
              classes.noRecord
            )}
          >
            {FLABEL().ERROR_NO_ERROR_ORDERS}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorTable;
